/**
 * Waritto 通知フック
 * 共通フックを使用し、Waritto関連の通知タイプのみフィルタ
 */
import {
  useNotifications as useNotificationsCore,
  useMarkNotificationRead as useMarkNotificationReadCore,
  useMarkAllNotificationsRead as useMarkAllNotificationsReadCore,
  useDeleteNotification as useDeleteNotificationCore,
  notificationKeys,
} from "@tabipla/hooks/notifications";
import type { NotificationType } from "@tabipla/shared";
import { apiClient } from "../../infrastructure/api/client";

// Re-export query keys for direct access if needed
export { notificationKeys };

// Notification types relevant to Waritto (割り勘アプリ)
const WARITTO_NOTIFICATION_TYPES: NotificationType[] = [
  "group_invite",
  "member_joined",
  "expense_added",
  "payment_request",
  "payment_completed",
];

// Waritto filters to group/expense-related notifications
export function useNotifications() {
  return useNotificationsCore({
    apiClient,
    filterTypes: WARITTO_NOTIFICATION_TYPES,
  });
}

export function useMarkNotificationRead() {
  return useMarkNotificationReadCore({ apiClient });
}

export function useMarkAllNotificationsRead() {
  return useMarkAllNotificationsReadCore({ apiClient });
}

export function useDeleteNotification() {
  return useDeleteNotificationCore({ apiClient });
}
